import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Pencil } from "lucide-react";

const LabelsEditorModal = ({
  open,
  onOpenChange,
  productLabels,
  labelsForm,
  setLabelsForm,
  savingLabels,
  onSave,
  onReset,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-slate-800 border-slate-700 text-white max-w-lg" data-testid="labels-editor-modal">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Pencil className="w-4 h-4 text-amber-400" />
            Modifier les libellés du modal "Ajouter un produit"
          </DialogTitle>
          <p className="text-xs text-slate-400 mt-1">
            Personnalise le titre et la description vus par toutes les caissières lorsqu'elles ouvrent ce formulaire.
            {productLabels?.is_custom && (
              <span className="ml-2 text-emerald-300">· Libellés personnalisés actifs</span>
            )}
          </p>
        </DialogHeader>
        <div className="space-y-4">
          <div className="space-y-2">
            <Label className="text-slate-300">Titre — mode création</Label>
            <Input
              value={labelsForm.title_create}
              onChange={(e) => setLabelsForm({ ...labelsForm, title_create: e.target.value })}
              placeholder="Ex: Ajouter un article au menu"
              maxLength={80}
              className="bg-slate-900 border-slate-700"
              data-testid="labels-title-create"
            />
            <p className="text-[10px] text-slate-500">{labelsForm.title_create.length}/80 caractères</p>
          </div>
          <div className="space-y-2">
            <Label className="text-slate-300">Titre — mode modification</Label>
            <Input
              value={labelsForm.title_edit}
              onChange={(e) => setLabelsForm({ ...labelsForm, title_edit: e.target.value })}
              placeholder="Ex: Modifier larticle"
              maxLength={80}
              className="bg-slate-900 border-slate-700"
              data-testid="labels-title-edit"
            />
            <p className="text-[10px] text-slate-500">{labelsForm.title_edit.length}/80 caractères</p>
          </div>
          <div className="space-y-2">
            <Label className="text-slate-300">Description (optionnelle)</Label>
            <Input
              value={labelsForm.description}
              onChange={(e) => setLabelsForm({ ...labelsForm, description: e.target.value })}
              placeholder="Ex: Renseignez nom, catégorie et prix de vente"
              maxLength={160}
              className="bg-slate-900 border-slate-700"
              data-testid="labels-description"
            />
            <p className="text-[10px] text-slate-500">{labelsForm.description.length}/160 caractères</p>
          </div>

          {/* Aperçu temps réel */}
          <div className="rounded-lg border border-amber-500/30 bg-amber-500/5 p-3">
            <p className="text-[10px] uppercase tracking-wider text-amber-300 mb-1">Aperçu</p>
            <p className="text-white font-semibold">
              {labelsForm.title_create || "Ajouter un produit"}
            </p>
            {labelsForm.description ? (
              <p className="text-xs text-slate-400 mt-1">{labelsForm.description}</p>
            ) : null}
          </div>

          <div className="flex gap-2 justify-end pt-2 flex-wrap">
            {productLabels?.is_custom && (
              <Button
                variant="outline"
                onClick={onReset}
                disabled={savingLabels}
                className="border-slate-600 text-slate-300 hover:bg-slate-700"
                data-testid="labels-reset-btn"
              >
                Restaurer les défauts
              </Button>
            )}
            <Button
              variant="ghost"
              onClick={() => onOpenChange(false)}
              disabled={savingLabels}
              className="text-slate-300"
            >
              Annuler
            </Button>
            <Button
              onClick={onSave}
              disabled={savingLabels || !labelsForm.title_create.trim() || !labelsForm.title_edit.trim()}
              className="bg-amber-500 hover:bg-amber-600 text-white"
              data-testid="labels-save-btn"
            >
              {savingLabels ? "Enregistrement…" : "Enregistrer"}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default LabelsEditorModal;
